/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["distributions-new-distribution .card-divider{border-bottom:1px solid #e0e0e0}distributions-new-distribution .mat-expansion-panel-header-title{margin-right:0}distributions-new-distribution .mat-expansion-panel-header-description{justify-content:flex-end;margin-right:0;align-items:flex-end}@media screen and (max-width:599px){distributions-new-distribution .mat-expansion-panel-header-description{font-size:12px}}"];
export { styles as styles };
